import * as React from 'react';
import { cn } from '@/app/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-10 w-full rounded-8 border border-system-white12 bg-system-bg04 px-3 py-2 text-sm text-system-white64 ring-offset-system-bg06 file:border-0 file:bg-transparent file:font-medium file:text-sm placeholder:text-system-text04 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
